module.exports = __webpack_public_path__ + "public/fonts/Siemens_Global_CC_Bold.6630cfe5.woff";